export default function Step2DataEntry({
  msg,
  tourName,
  seatAvailable,
  boatCapacity,
  register,
  nameBoat,
  boatOption,
  onSelectBoat,
  adultAge,
  childAge,
  infantAge,
  onClickPlusAdult,
  onClickMinusAdult,
  numOfAdult,
  onClickPlusChild,
  onClickMinusChild,
  numOfChild,
  onClickPlusInfant,
  onClickMinusInfant,
  numOfInfant,
  onClickClose,
  onClickBack,
  onClickSubmit,
  isShowButtonSubmit,
  title,
}) {
  return (
    <div className="step_selection">
      <div className="title_step_selection">{title}</div>
      <div className="step_indicator">
        <div className="point">
          <div className="pass">1</div>
          <p>{msg.select_tour_and_date}</p>
        </div>
        <span className="pass" />
        <div className="point">
          <div className="pass">2</div>
          <p>{msg.select_boat}</p>
        </div>
      </div>
      <div className="container_step_2">
        <div className="tour_and_seat">
          <h2>{tourName}</h2>
          <h3>
            <span className="tour_name">{`${msg.seat_available}: ${seatAvailable} ${msg.pax}`}</span>
            <span className="seat">{`/${boatCapacity} ${msg.pax}`}</span>
          </h3>
        </div>
        <div className="boat_selection_and_passenger">
          <div className="_input_text_select select_boat">
            <label>{`${msg.boat_name} *`}</label>
            <select
              {...register(nameBoat, {
                required: true,
                onChange: onSelectBoat,
              })}
            >
              {boatOption.map((el, index) => (
                <option key={index} value={el.value} label={el.label} />
              ))}
            </select>
          </div>
          <div className="select_num_of_passenger">
            <label>
              <span>{msg["adult(s)"]}</span>
              <span className="age_label">{`(${msg.over} ${adultAge})`}</span>
            </label>
            <span>
              <button onClick={onClickMinusAdult}>-</button>
              <label>{numOfAdult}</label>
              <button onClick={onClickPlusAdult}>+</button>
            </span>
          </div>
          <div className="select_num_of_passenger">
            <label>
              <span>{msg["child(s)"]}</span>
              <span className="age_label">{`(${msg.under} ${adultAge})`}</span>
            </label>
            <span>
              <button onClick={onClickMinusChild}>-</button>
              <label>{numOfChild}</label>
              <button onClick={onClickPlusChild}>+</button>
            </span>
          </div>
          <div className="select_num_of_passenger">
            <label>
              <span>{msg["infant(s)"]}</span>
              <span className="age_label">{`(${msg.under} ${infantAge})`}</span>
            </label>
            <span>
              <button onClick={onClickMinusInfant}>-</button>
              <label>{numOfInfant}</label>
              <button onClick={onClickPlusInfant}>+</button>
            </span>
          </div>
        </div>
      </div>
      <div className="footer_button">
        <span className="left">
          <button onClick={onClickBack}>
            {"< "}
            {msg.back}
          </button>
        </span>
        <span className="right">
          <button onClick={onClickClose}>{msg.close}</button>
          {isShowButtonSubmit && (
            <button onClick={onClickSubmit}>{msg.submit}</button>
          )}
        </span>
      </div>
    </div>
  );
}
